<script lang="ts">
	// eslint-disable-next-line import-x/no-duplicates
	import { onMount } from 'svelte'
	// eslint-disable-next-line import-x/no-duplicates
	import { on } from 'svelte/events'
	import { deepMerge, MetaTags } from 'svelte-meta-tags'

	import { afterNavigate, beforeNavigate } from '$app/navigation'
	import { page, navigating } from '$app/state'
	import BottomToast from '#lib/components/bottom-toast.svelte'
	import LoadingBar from '#lib/components/loading-bar.svelte'
	import { Button } from '#lib/components/ui/button/index.js'
	import {
		getListedDialog,
		mobileMenu,
		searchDialog,
		updateMobileMenu,
		updateSearchDialog,
	} from '#lib/utils/dialogs.svelte.js'
	import { updateN } from '#lib/utils/navigation.svelte.js'
	import { detectDevice, detectDeviceType, phg } from '#lib/utils/posthog.js'

	// eslint-disable-next-line import-x/no-unassigned-import
	import '../app.css'

	let { data, children } = $props()
	let open = $state(true)

	onMount(() => {
		phg.identify(data.user, {
			$device_type: detectDeviceType(window.navigator.userAgent),
			$device: detectDevice(window.navigator.userAgent),
		})

		on(window, 'vite:preloadError', () => window.location.reload())

		if (import.meta.env.MODE === 'production') {
			// eslint-disable-next-line no-console
			console.info(
				`%cChainspect\n%cHi! Do you need our data? Contact us by email contact@chainspect.app or in Telegram @chainspect_app and we'll try to help you with the data you need!`,
				`
				font-family: Montserrat, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
				font-size: 32px;
				font-weight: 600;
				line-height: 1.5;
				background: linear-gradient(to right, rgb(2, 125, 253), rgb(27, 230, 171));
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
			`,
				`
				font-family: Montserrat, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
				padding: 10px;
				font-size: 14px;
				line-height: 1.2;
				background: rgb(31, 41, 55);
				color: rgb(255, 255, 255);
			`
			)
		}
	})

	let loaderTimeout: ReturnType<typeof setTimeout>

	$effect(() => {
		if (navigating.from?.url.pathname !== navigating.to?.url.pathname) {
			updateN(true)
			updateSearchDialog(false)
			updateMobileMenu(false)
		} else if (navigating.to?.url.search !== navigating.from?.url.search) {
			clearTimeout(loaderTimeout)
			loaderTimeout = setTimeout(() => updateN(true), 200)
		} else {
			clearTimeout(loaderTimeout)
			updateN(false)
		}
	})

	afterNavigate(({ from, shallow, type }) => {
		if (shallow && type === 'goto') return

		return phg.capture('$pageview', {
			$device_type: detectDeviceType(window.navigator.userAgent),
			$device: detectDevice(window.navigator.userAgent),
			utm_source: from?.url.searchParams.get('utm_source') ?? null,
			utm_medium: from?.url.searchParams.get('utm_medium') ?? null,
			utm_campaign: from?.url.searchParams.get('utm_campaign') ?? null,
			utm_content: from?.url.searchParams.get('utm_content') ?? null,
			utm_term: from?.url.searchParams.get('utm_term') ?? null,
		})
	})

	beforeNavigate(({ from, shallow, type }) => {
		if (shallow && type === 'goto') return

		return phg.capture('$pageleave', {
			$prev_pageview_pathname: from?.url.pathname ?? null,
			$device_type: detectDeviceType(window.navigator.userAgent),
			$device: detectDevice(window.navigator.userAgent),
		})
	})
</script>

<MetaTags {...deepMerge(data.baseMetaTags, page.data.pageMetaTags)} />

<LoadingBar />

{@render children?.()}

{#if getListedDialog.open}
	{#await import('#lib/components/dialogs/get-listed-dialog.svelte') then GetListedDialog}
		<GetListedDialog.default />
	{/await}
{/if}

{#if searchDialog.open}
	{#await import('#lib/components/dialogs/search-dialog.svelte') then SearchDialog}
		<SearchDialog.default />
	{/await}
{/if}

{#if mobileMenu.open}
	<!-- eslint-disable-next-line import-x/max-dependencies -->
	{#await import('#lib/layouts/mobile-menu.svelte') then MobileMenu}
		<MobileMenu.default />
	{/await}
{/if}

{#if page.url.pathname.includes('fogo')}
	<Button
		class="fixed right-3 bottom-4 left-3 z-15 text-lg md:right-5 md:bottom-6 md:left-auto"
		href="https://app.ignitionfi.xyz/?ref=j1q8j1l7qv"
		onclick={() => phg.capture('ifogo_click')}
		rel="noopener noreferrer"
		size="lg"
		target="_blank"
		variant="ifogo"
	>
		Stake Now
	</Button>
{:else if open}
	<BottomToast bind:open />
{/if}
